// extracted by mini-css-extract-plugin
export default {"TwoDimsFeature":"wv_a bik_b bik_we"};